import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
let ls = new SecureLS({ isCompression: false });
import firebase from "firebase";
import ENV from './modules/environtment'
import GlobalConfig from './modules/GlobalConfig'
import Notification from './modules/Notification'
import PayrollModule from "./modules/Payroll.module";
import MasterDataModule from './modules/MasterData.module'
import EmployeeModule from './modules/Employee.Module'
import ZoneModule from './modules/Zone.module'
import ReportModule from './modules/Report.module'
import TaskAssignment from './modules/TaskAssignment.module'
import CalendarModule from './modules/Calendar.Module'
import NewsFeedModule from './modules/Newsfeed.module'
import MaintenanceModule from './modules/Maintenance.Module'
import LeaveModule from './modules/Leave.Module'
import i18n  from './../i18n' 

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    baseUrl: ENV.api,
    reportUrl: ENV.report,
    testUrl: ENV.test,
    user: {},
    user_name: null,
    user_email: null,
    user_avatar: null,
    company: null,
    companyName: null,
    cutoff_date: null,
    status: null,
    error: null,
    error_login: null,
    authenticated: false,
    administrator: false,
    group_id: null,
    user_manual: '',
    companyDrawer: false,
    profileDrawer: false,
    companyDetail: {},
    gcCompany: null,
    showPICModal: false,
    showChangePlanModal: false,
    showOverQuotaModal: false,
    billingInfo: {},
    gcUser: {},
    user_gc: {},
    group_gc: {},
    company_gc: {},
    approval_gc: {},
    globalConfig: GlobalConfig.state,
    notification: Notification.state,
    payroll: PayrollModule.state,
    gcParams: {},
    validator: {
      numberNotRequired: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[0-9 .,-]+$/.test(v)) return true;
        return i18n.t('number_required');
      },
      numberOnly: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[0-9]+$/.test(v)) return true;
        return i18n.t('number_required');
      },
      alfaForName: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[a-zA-Z0-9 )(.',-]+$/.test(v)) return true;
        return i18n.t('alfanumeric_required');
      },
      alfaForInput: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[a-zA-Z0-9 -]+$/.test(v)) return true;
        return i18n.t('alfanumeric_required');
      },
      alfaForID: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[a-zA-Z0-9 /_.-]+$/.test(v)) return true;
        return i18n.t('alfanumeric_required');
      },
      
      alfaNumberNotRequired: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[a-zA-Z0-9 @.,-]+$/.test(v)) return true;
        return i18n.t('alfanumeric_required');
      },
      GroupRequired: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[a-zA-Z0-9 )(+&_/.,-]+$/.test(v)) return true;
        return i18n.t('alfanumeric_required');
      },
      alfaForEmail: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[a-zA-Z0-9 @.'+,-]+$/.test(v)) return true;
        return i18n.t('alfanumeric_required');
      },
      alfaForNews: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[a-zA-Z0-9 @.=:%?/'+,-]+$/.test(v)) return true;
        return i18n.t('alfanumeric_required');
      },
      email: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[a-zA-Z0-9 @+_.,-]+$/.test(v)) return true;
        return i18n.t('alfanumeric_required');
      },
      zoneRequired: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[a-zA-Z0-9 )(+.,-]+$/.test(v)) return true;
        return i18n.t('alfanumeric_required');
      },
      titleRequired: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[a-zA-Z0-9 )(+&/.,-]+$/.test(v)) return true;
        return i18n.t('alfanumeric_required');
      },
      componentRequired: v  => {
        // eslint-disable-next-line no-console
        // console.log(v, v? true: false )
        if (v) { if (!v.toString().trim()) return true; } 
        else { return true; }
        if (/^[a-zA-Z0-9 )(%+@.,-]+$/.test(v)) return true;
        return i18n.t('alfanumeric_required');
      },
    }
    // :rules="[validator.alfaNumberNotRequired]"
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
  mutations: {

    TOGGLE_PIC_MODAL(state, payload) {
      state.showPICModal = payload
    },
    TOGGLE_CHANGE_PLAN_MODAL(state, payload) {
      state.showChangePlanModal = payload
    },
    TOGGLE_OVERQUOTA_MODAL(state, payload) {
      state.showOverQuotaModal = payload
    },
    SET_CCMPANY_DETAIL(state, payload) {
      state.companyDetail = payload;
    },
    SET_AUTHENTICATED(state, payload) {
      state.authenticated = payload;
    },
    SET_USER(state, payload) {
      state.user.id = payload.uid;
      state.user.name = payload.displayName;
      state.user.email = payload.email;
      state.user.avatar = payload.avatar
      if (payload.administrator === true) {
        state.administrator = true;
      }
    },
    SET_USER_MANUAL(state, payload){
      state.user_manual = payload
    },
    SET_USER_DETAIL(state, payload) {
      state.user.detail = payload
    },
    SET_USERNAME(state, payload) {
      state.user_name = payload;
    },
    SET_USEREMAIL(state, payload) {
      state.user_email = payload;
    },
    SET_ADMINISTRATOR(state, payload) {
      state.administrator = payload;
    },
    CLEAR_USER(state) {
      state.user = {};
      state.user_name = null;
      state.user_email = null;
      state.user_avatar = null;
      state.company = null;
      state.authenticated = false;
      state.status = null;
      state.administrator = false;
      state.globalConfig = null;
      state.group_id = null;
    },
    SET_GC_COMPANY(state, payload) {
      state.gcCompany = payload;
    },
    SET_COMPANY(state, payload) {
      state.company = payload;
    },
    SET_COMPANY_NAME(state, payload) {
      state.companyName = payload;
    },
    SET_CUTOFF_DATE(state, payload) {
      state.cutoff_date = payload;
    },
    SET_STATUS(state, payload) {
      state.status = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
    SET_ERROR_LOGIN(state, payload) {
      state.error_login = payload;
    },
    SET_GROUP_ID(state, payload) {
      state.group_id = payload;
    },
    SET_ROLE(state, payload) {
      state.role = payload;
    },
    SET_COMPANY_DRAWER(state, payload) {
      state.companyDrawer = payload
    },
    SET_PROFILE_DRAWER(state, payload) {
      state.profileDrawer = payload
    },
    SET_BILLING_INFO(state, payload) {
      state.billingInfo = payload
    },
    ...GlobalConfig.mutations,
    ...Notification.mutations,
    ...PayrollModule.mutations,
  },
  getters: {
    baseUrl(state) {
      return state.baseUrl
    },
    reportUrl(state) {
      return state.reportUrl
    },
    user(state) {
      return state.user;
    },
    company(state) {
      return state.company;
    },
    companyName(state) {
      return state.companyName;
    },
    cuttOffDate(state) {
      return state.cutoff_date;
    },
    status(state) {
      return state.status;
    },
    error(state) {
      return state.error;
    },
    errorLogin(state) {
      return state.error_login;
    },
    authenticated(state) {
      return state.authenticated;
    },
    group_id(state) {
      return state.group_id;
    },
    companyDetail(state) {
      return state.companyDetail;
    },
    getShowPICModal(state) {
      return state.showPICModal
    },
    getshowChangePlanModal(state) {
      return state.showChangePlanModal
    },
    getShowOverQuotaModal(state) {
      return state.showOverQuotaModal
    },
    getBillingInfo(state) {
      return state.billingInfo
    },
    ...GlobalConfig.getters,
    ...Notification.getters,
    ...PayrollModule.getters,
  },
  actions: {
    SET_CCMPANY_DETAIL(context, payload) {
      context.commit('SET_CCMPANY_DETAIL', payload)
    },
    async signIn(context, payload) {
      this.state.baseUrl = ENV.api
      return await firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(async (res) => {
          // get user firebase token
          // res.user.getIdToken().then((data) => {
       
          // });
          const storage = firebase.storage()
          const userManual = await storage.refFromURL(`gs://appsensi-dev.appspot.com/files/production/manual/User Manual Appsensi.zip`).getDownloadURL().catch(() => { return '-' })
          const avatar = await storage.refFromURL(`gs://appsensi-dev.appspot.com/images/avatars/${res.user.uid}`).getDownloadURL().catch(() => { return '-' })
          res.user.avatar = avatar
          context.commit("SET_USER", res.user);
          context.commit("SET_USER_MANUAL", userManual);
          
          const data = await context.dispatch('getGlobalConfig', { userId: res.user.uid })
          const body = {
            collection: ENV.firebase.globalConfig,
            companyId: data.company.id,
            isLogin: true
          }
          context.commit('setParamGlobalConfig', body)
          await context.dispatch('gcGetDataCompany', body)
          await context.dispatch('setDataLogin', data)
        }).catch((err) => {
          context.commit("SET_STATUS", "failed");
          context.commit("SET_ERROR", err.message);
          context.commit("SET_ERROR_LOGIN", err.code);
        });
    },
    signOut(context) {
      context.commit("CLEAR_USER");
    },
    
    companyDrawer(context, payload) {
      if (this.state.profileDrawer) {
        context.commit("SET_PROFILE_DRAWER", false)
        setTimeout(() => {
          context.commit("SET_COMPANY_DRAWER", payload)
        }, 300);
      } else {
        if (this.state.companyDrawer) {
          context.commit("SET_COMPANY_DRAWER", false)
          setTimeout(() => {
            context.commit("SET_COMPANY_DRAWER", payload)
          }, 100);
        } else {
          context.commit("SET_COMPANY_DRAWER", payload)
        }
      }
    },
    profileDrawer(context, payload) {
      if (this.state.companyDrawer) {
        context.commit("SET_COMPANY_DRAWER", false)
        setTimeout(() => {
          context.commit("SET_PROFILE_DRAWER", payload)
        }, 300)
      } else {
        if (this.state.profileDrawer) {
          context.commit("SET_PROFILE_DRAWER", false)
          setTimeout(() => {
            context.commit("SET_PROFILE_DRAWER", payload)
          }, 100);
        } else {
          context.commit("SET_PROFILE_DRAWER", payload)
        }
      }
    },
    togglePICModal(context, payload) {
      context.commit("TOGGLE_PIC_MODAL", payload)
    },
    toggleChangePlanModal(context, payload) {
      context.commit("TOGGLE_CHANGE_PLAN_MODAL", payload)
    },
    toggleOverQuotaModal(context, payload) {
      context.commit("TOGGLE_OVERQUOTA_MODAL", payload)
    },
    ...GlobalConfig.actions,
    ...Notification.actions,
    ...PayrollModule.actions,
    ...MasterDataModule.actions,
    ...EmployeeModule.actions,
    ...ZoneModule.actions,
    ...ReportModule.actions,
    ...TaskAssignment.actions,
    ...CalendarModule.actions,
    ...NewsFeedModule.actions,
    ...MaintenanceModule.actions,
    ...LeaveModule.actions,
  },
});
